import {
  ORG_PROFILE_SET_ORG_DETAILS,
  ORG_PROFILE_SET_ORG_MASTER,
  ORG_PROFILE_SET_PROFILE_DATA,
  ORG_PROFILE_LOADING,
  TOGGLE_SHOW_HOME_PAGE,
} from 'src/actions/constants';

const defaultState = {
  loading: false,
  orgDetails: { showHomePage: false },
  orgMaster: {},
  orgProfile: {},
  filters: {},
  pagination: {},
};
export default function (state = defaultState, action) {
  switch (action.type) {
    case TOGGLE_SHOW_HOME_PAGE: {
      return {
        ...state,
        orgDetails: {
          ...state.orgDetails,
          showHomePage: !state.orgDetails.showHomePage,
        }
      }
    }
    case ORG_PROFILE_SET_ORG_DETAILS: {
      return {
        ...state,
        orgDetails: action.data,
      };
    }
    case ORG_PROFILE_SET_ORG_MASTER: {
      return {
        ...state,
        orgMaster: action.data,
      };
    }
    case ORG_PROFILE_SET_PROFILE_DATA: {
      return {
        ...state,
        orgProfile: action.data,
      };
    }
    case ORG_PROFILE_LOADING: {
      return {
        ...state,
        loading: action.value,
      };
    }
    default : return state;
  }
}
